export class Preferences {
	private _store: {[key:string]: any} = {};
	constructor(
		private _key: string | undefined = undefined
	) {
		this.setup();
		
		if (this.canUseLocalStorage) {
			// When a storage event is received, update the local store
			window.addEventListener('storage', () => this.readFromStorage());
		}
	}
	
	get storeKey() {
		return `${this.key}.preferences`
	}
	
	get key() {
		return this._key;
	}
	
	set key(val) {
		this._key = val;
		this.setup();
		
	}
	
	private get canUseLocalStorage() {
		try {
			return this.key !== undefined && this.key !== null && !!window.localStorage;
		}
		catch (e) {
			console.debug(`Could not access local storage`);
			return false;
		}
	}
	
	hasValue(key: string) {
		return key in this._store;
	}
	
	setValue(key: string, value: object | number | string | boolean) {
		this._store[key] = value;
		this.persistToStorage();
	}
	
	clearValue(key: string) {
		if (delete this._store[key])
		{
			this.persistToStorage();
		}
	}
	
	getValue(key: string, defaultVal?: object | number | string | boolean) {
		const val = this._store[key];
		return val !== undefined ? val : defaultVal;
	}
	
	private setup() {
		this._store = {};
		this.readFromStorage();
	}
	
	private persistToStorage() {
		if (!this.canUseLocalStorage) return;
		try {
			const storeStr = JSON.stringify(this._store);
			window.localStorage.setItem(this.storeKey, storeStr);
		}
		catch (e) {
			console.error('Error persisting to local storage', e);
		}
	}
	
	private readFromStorage() {
		if (!this.canUseLocalStorage) return;
		
		try {
			const readInStr = window.localStorage.getItem(this.storeKey);
			if (readInStr !== null)
			{
				let store = JSON.parse(readInStr);
				// If the retrieved object is not valid, reset it.
				if (store === null || store === undefined || !(typeof store === "object"))
					store = {};
				this._store = store;
			}
		} catch (e) {
			console.error(`Error reading local storage`, e);
			this._store = {};
		}
	}
}